// Lifted from useFiveSegmentsTableColumns; pure so basic-output can reuse without React/Jotai.

import * as R from 'remeda'

import {
  type ColumnInfo,
  compact,
  fiveSegmentIndicators,
  fiveSegments,
  mapFiveSegment,
} from '~/utils'

import { type FiveSegmentColumnKey as ColumnKey } from './fiveSegments'

const widthMap: Record<ColumnKey, string> = {
  brandNumber: 'max-content',
  brandName: 'max-content',
  ...mapFiveSegment(() => '6em'),
  indicatorPad: '0.5rem',
  ...R.mapToObj(fiveSegmentIndicators, (indicator) => [indicator, '8em']),
}

export const buildFiveSegmentsTableColumns = ({
  hiddenColumnKeys,
}: {
  hiddenColumnKeys: ReadonlyArray<ColumnKey>
}): ColumnInfo<ColumnKey>[] => {
  const visibleFiveSegments = R.difference(
    R.reverse(fiveSegments),
    hiddenColumnKeys,
  )
  const visibleIndicators = R.difference(
    fiveSegmentIndicators,
    hiddenColumnKeys,
  )

  const hasIndicatorPad =
    0 < visibleFiveSegments.length && 0 < visibleIndicators.length

  const columnKeys: ColumnKey[] = compact([
    'brandNumber',
    'brandName',
    ...visibleFiveSegments,
    hasIndicatorPad && 'indicatorPad',
    ...visibleIndicators,
  ])

  return columnKeys.map((key) => ({ key, width: widthMap[key] }))
}
